<template>
    <Dialog @update:open="$event ? onOpen() : onClose()">
        <DialogContent id="login-modal">
            <!-- Step 1 - Login or Continue as Guest -->
            <div v-if="step == 0">
                <h3 class="text-primary uppercase">
                    {{ $t("BOMTool.AddToBOM") }}
                </h3>
                <h2 class="text-3xl font-medium">{{ $t("SignIn.WouldYouLikeToLogin") }}</h2>
                <p class="text-xl font-light text-muted mb-8">
                    {{ $t("SignIn.LoginForAdvancedFeatures") }}
                </p>
                <div class="flex justify-center gap-1">
                    <DialogClose as-child>
                        <button class="btn" type="button" @click="continueAsGuest">
                            {{ $t("SignIn.ContinueAsGuest") }}
                        </button>
                    </DialogClose>
                    <button class="btn btn-bg-primary" type="button" @click="login">
                        {{ $t("SignIn.LoginButtonText") }}
                    </button>
                </div>
            </div>

            <!-- Step 2 - Login Form -->
            <div v-if="step == 1">
                <h3 class="text-primary uppercase">
                    {{ $t("SignIn.LoginButtonText") }}
                </h3>
                <br />
                <LoginForm :login-url="loginUrl" />
            </div>
        </DialogContent>
    </Dialog>
</template>

<script setup>
const { gtag } = useGtag();

const emit = defineEmits(["close"]);

const apiPath = useApiLocaleUrl();
const loginUrl = apiPath("api/account/sign-in");
const step = ref(0);

function onOpen() {
    trackEvent("sign_in_modal_open");
}

function onClose() {
    emit("close");
}

function continueAsGuest() {
    // set a cookie to not bother this user for another 90 days.
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + CONTINUE_AS_GUEST_EXPIRATION);
    PageHelpers.SetCookie(CONTINUE_AS_GUEST_FLAG, "true", expiry, "/");

    trackEvent("sign_in_modal_continue_as_guest");
}

function login() {
    trackEvent("sign_in_modal_sign_in");
    step.value = 1;
}

function trackEvent(event) {
    gtag("event", event);
}
</script>
